var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartLine',{attrs:{"datasets":_vm.dataSets,"options":_vm.options,"labels":_vm.labels}})}
var staticRenderFns = []

export { render, staticRenderFns }